import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import withSurveyDataInit from '../../library/withSurveyDataInit/withSurveyDataInit';
const LiveqStarter = () => {
    return (_jsx(_Fragment, {}));
};
export default withSurveyDataInit(observer(LiveqStarter));
